import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperacaoFinanceiraAppRoutingModule } from './operacao-financeira.app-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    OperacaoFinanceiraAppRoutingModule
  ]
})
export class OperacaoFinanceiraAppModule { }
